export const money = (pence: number, currency = "GBP") =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency }).format((pence || 0) / 100);

export const shortDate = (iso: string) =>
  new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });

export const dateTime = (iso: string) =>
  new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export const titleCase = (s: string) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export type WineColour = "red" | "white" | "rosé" | "sparkling" | "unknown";
const COLOUR_KEYS: [string, WineColour][] = [["sparkling", "sparkling"], ["champagne", "sparkling"], ["crémant", "sparkling"], ["cremant", "sparkling"], ["bubbles", "sparkling"], ["rosé", "rosé"], ["rose", "rosé"], ["white", "white"], ["blanc", "white"], ["red", "red"], ["rouge", "red"]];
/** Same heuristic as the backend `_colour()` — product type first, then tags, then title. */
export const colourOf = (...texts: (string | null | undefined)[]): WineColour => {
  const t = texts.filter(Boolean).join(" ").toLowerCase();
  for (const [k, v] of COLOUR_KEYS) if (t.includes(k)) return v;
  return "unknown";
};
export const COLOUR_LABEL: Record<WineColour, string> = { red: "red", white: "white", "rosé": "rosé", sparkling: "bubbles", unknown: "unplaced" };
